/**
 * Risposta a chi ha segnalato.
 *
 * Chiudere una segnalazione senza dirlo a chi l'ha scritta è il modo più
 * sicuro per far smettere di segnalare: la volta dopo si pensa che tanto non
 * serve. Qui la risposta compare al primo accesso utile, con la nota scritta
 * in fase di chiusura, e resta finché non viene letta.
 */
import { useEffect, useState } from 'react';
import { segnalazioniApi } from '../api';

export default function RisposteSegnalazioni() {
  const [risposte, setRisposte] = useState([]);

  useEffect(() => {
    let vivo = true;
    segnalazioniApi.mie()
      .then(r => { if (vivo) setRisposte(r || []); })
      .catch(() => {});   // silenzioso: è un di più, non deve mai disturbare
    return () => { vivo = false; };
  }, []);

  const chiudi = async (s) => {
    setRisposte(r => r.filter(x => x.id !== s.id));
    try { await segnalazioniApi.segnaLetta(s.id); } catch { /* la si rivedrà */ }
  };

  if (!risposte.length) return null;

  return (
    <div className="shrink-0">
      {risposte.map(s => {
        const risolta = s.stato === 'risolta';
        return (
          <div key={s.id}
               className={`px-4 py-2 flex items-start gap-3 text-sm border-b ${risolta
                 ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200'}`}>
            <span className="text-lg leading-none mt-0.5">{risolta ? '✓' : '•'}</span>
            <div className="flex-1 min-w-0">
              <div className={risolta ? 'text-green-800' : 'text-gray-700'}>
                La tua segnalazione <strong>«{s.titolo}»</strong>{' '}
                {risolta ? 'è stata risolta.' : 'è stata archiviata senza modifiche.'}
              </div>
              {s.note_admin && (
                <div className="text-xs text-gray-600 mt-0.5 whitespace-pre-wrap">{s.note_admin}</div>
              )}
            </div>
            <button onClick={() => chiudi(s)}
                    className="text-gray-400 hover:text-gray-700 shrink-0 px-1"
                    title="Ho letto">✕</button>
          </div>
        );
      })}
    </div>
  );
}
